import { formatPhone, normalizeZAphone } from "@/components/form-field/helpers/formatPhone"
import { Form, Input, InputProps, Select, SelectProps } from "antd"
import { FormInstance } from "antd/es/form"
import TextArea, { TextAreaProps } from "antd/es/input/TextArea"
import { FormItemProps, Rule } from "antd/es/form"
import React, { FC } from "react"
import { IMaskInput } from "react-imask"

import "../../../../styles/website-form-elements.less"

type WebsiteFormElementsType =
  | "input"
  | "input-email"
  | "input-phone-mask"
  | "tel-input"
  | "password"
  | "textarea"
  | "select"

type CustomProps = {
  type: WebsiteFormElementsType
  name: string
  required?: boolean
  placeholder?: string
  rows?: number
  minRows?: number
  suffix?: React.ReactNode
  rules?: Rule[]
  form?: FormInstance<any>
}

const WebsiteFormItem: FC<CustomProps & FormItemProps & InputProps & TextAreaProps & SelectProps> = ({
  type,
  name,
  required = false,
  placeholder,
  rows,
  minRows,
  suffix,
  rules,
  form,
  ...restProps
}) => {
  return (
    <>
      {type === "input" && (
        <Form.Item
          className={"website-form-item"}
          name={name}
          rules={[
            ...(required
              ? [{ required: true, message: `Please enter your ${placeholder?.replace(/^\*/, "").trim()}` }]
              : []),
            ...(rules || []),
          ]}
          {...restProps}
        >
          <Input placeholder={placeholder} className={"website-input"} suffix={suffix} {...restProps} />
        </Form.Item>
      )}

      {type === "input-email" && (
        <Form.Item
          className={"website-form-item"}
          name={name}
          rules={[
            { type: "email", message: "Please input a valid email!" },
            ...(required ? [{ required: true, message: "Please enter your email" }] : []),
            ...(rules || []),
          ]}
          {...restProps}
        >
          <Input placeholder={placeholder} className={"website-input"} {...restProps} />
        </Form.Item>
      )}

      {type === "input-phone-mask" && (
        <Form.Item
          className={"website-form-item"}
          name={name}
          rules={[
            {
              pattern: /^\+27 \(\d{2}\) \d{3}-\d{4}$/,
              message: "Please enter a valid phone number",
            },
            ...(required ? [{ required: true, message: "Please enter your phone" }] : []),
            ...(rules || []),
          ]}
          {...restProps}
        >
          <IMaskInput
            className={"ant-input website-input"}
            mask={"+27 (00) 000-0000"}
            placeholder={"+27 (00) 000-0000"}
            // onAccept={onAccept}
            onAccept={(value: string) => {
              form?.setFieldsValue({ [name]: value })
            }}
          />
        </Form.Item>
      )}

      {type === "tel-input" && (
        <Form.Item
          name={name}
          className={"website-form-item"}
          required={required}
          rules={[
            { required, message: "This field is required" },
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve()

                const cleaned = normalizeZAphone(value)

                if (cleaned.length === 10) {
                  return Promise.resolve()
                }

                return Promise.reject("Enter a valid phone number")
              },
            },
          ]}
          getValueFromEvent={e => formatPhone(e.target.value)}
        >
          <Input placeholder={placeholder} className={"website-input"} {...restProps} />
        </Form.Item>
      )}

      {type === "textarea" && (
        <Form.Item className={"website-form-item contact-message"} name={name} {...restProps}>
          <TextArea
            placeholder={placeholder}
            rows={rows}
            className={"website-input"}
            autoSize={{ minRows }}
            {...restProps}
          />
        </Form.Item>
      )}

      {type === "select" && (
        <Form.Item
          className={"website-form-item"}
          name={name}
          {...restProps}
          rules={[...(required ? [{ required: true, message: "Please select an option" }] : []), ...(rules || [])]}
        >
          <Select placeholder={placeholder} className={"website-select"} {...restProps} />
        </Form.Item>
      )}
    </>
  )
}

export default WebsiteFormItem
